document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.custom-collections-carousel .carousel-container');
  
  carousels.forEach(function(carousel) {
    if (!$(carousel).hasClass('slick-initialized')) {
      $(carousel).slick({
        infinite: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });
});